.eventContainer {
    display: flex;
    flex-direction: row;
    gap: 15px;
    row-gap: 30px;
    flex-wrap: wrap;
}
